import React from "react";
import PropTypes from "prop-types";
// import SwipeableViews from "react-swipeable-views";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Tabs, Tab, Box } from "@material-ui/core";
import { School, Description, Speed, DateRange } from "@material-ui/icons";

import DashboardTab from "./Tabs/MainTab/DashboardTab";
import CalendarTab from "./Tabs/CalendarTab/CalendarTab";
import DocumentsTab from "./Tabs/DocumentsTab/DocumentsTab";
import AdvisorTab from "./Tabs/AdvisorTab";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    position: "fixed",
    top: 80,
    width: 800,
    height: "90vh",
    maxHeight: 840,
    display: "flex",
    flexDirection: "column",
    // overflowY: "scroll",
    // '&::-webkit-scrollbar': {
    //   display: "none"
    // },
    // marginBottom: "2vh"
  },
  tabs:{
    overflowY: "scroll",
    '&::-webkit-scrollbar': {
      display: "none"
    },
    marginBottom: theme.spacing(3),
  }
}));

export default function TabsBar() {
  const classes = useStyles();
  // const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Paper square>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="dashboard tabs"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab icon={<School />} label="Main" {...a11yProps(0)} />
          <Tab icon={<DateRange />} label="Calendar" {...a11yProps(1)} />
          <Tab icon={<Description />} label="Documents" {...a11yProps(2)} />
          <Tab icon={<Speed />} label="AI Advisor" {...a11yProps(3)} />
        </Tabs>
      </Paper>
        <TabPanel value={value} index={0} className={classes.tabs}>
          <DashboardTab />
        </TabPanel>
        <TabPanel value={value} index={1} className={classes.tabs}>
          <CalendarTab />
        </TabPanel>
        <TabPanel value={value} index={2} className={classes.tabs}>
          <DocumentsTab />
        </TabPanel>
        <TabPanel value={value} index={3} className={classes.tabs}>
          <AdvisorTab />
        </TabPanel>
    </div>
  );
}
